import axios from 'axios';
import { mapState } from 'vuex';

import PageHeader from '@/components/widgets/PageHeader/PageHeader.vue';
import Loading from '@/components/widgets/Loading/Loading.vue';

import PasswordInput from '@/components/PasswordInput.vue';
import { handleAPIError, ERROR_TYPE } from '@/utils/errorHelper';
import { smartFocus } from '@/utils/uiHelper';

// @vue/component
export default {
  name: 'ForgotPassword',
  components: {
    PageHeader,
    Loading,
    PasswordInput,
  },
  data() {
    return {
      userId: 0,
      token: '',

      password: '',

      state: 'normal',
      formError: '',
      isLoading: false,
    };
  },
  created() {
    this.userId = this.$route.params.userId;
    this.token = this.$route.params.token;

    this.validateResetToken();
  },
  mounted() {
    smartFocus();
  },
  computed: {
    ...mapState({
      apps: (state) => state.site.siteInfo.apps,
      siteURL: (state) => state.site.siteInfo.url,
    }),
    canSubmit() {
      return this.password.length;
    },
    title() {
      if (this.state === 'success') return 'Password updated';
      return 'Reset password';
    },
    subTitle() {
      if (this.state === 'success' && this.user) {
        return `${this.user.FirstName}, your password has been changed.`;
      }
      return 'Please enter the desired password for your account below.';
    },
  },
  watch: {
    isLoading() {
      window.parent.postMessage('pageResized', '*');
    },
  },
  methods: {
    validateResetToken() {
      axios.get(`/launchpad/v1/validatereset/${this.userId}/${this.token}`).then((response) => {
        this.user = response.data.user;
        this.isLoading = false;
      }).catch(() => {
        this.$store.commit('showFatalError', {
          error: 'Token Expired',
          // eslint-disable-next-line
          explanation: 'Sorry we couldn\'t authorise this request. It\'s most likely that the link has expired.',
          appError: 'access_denied',
          appErrorExplanation: 'reset token has expired',
        });
        this.isLoading = false;
      });
    },

    onSubmitReset() {
      if (this.isLoading || !this.canSubmit) return false;
      this.isLoading = true;
      this.formError = '';
      return axios.post(
        `/launchpad/resetpassword/${this.userId}/${this.token}`,
        `password=${encodeURIComponent(this.password)}`,
      ).then(() => {
        this.state = 'success';
        this.isLoading = false;
      }).catch((e) => {
        const err = handleAPIError(
          this.$store, e,
          'unknown error',
        );
        console.log(err, err.type, err.err);
        if (err && err.type === ERROR_TYPE.FORM_ERROR && err.err !== 'unknown error') {
          this.formError = err.err;
        } else {
          this.$store.commit('showFatalError', {
            error: 'Token Expired',
            // eslint-disable-next-line
            explanation: 'Sorry we couldn\'t authorise this request. It\'s most likely that the link has expired.',
            appError: 'access_denied',
            appErrorExplanation: 'reset token has expired',
          });
        }
        this.isLoading = false;
      });
    },
    reload() {
      window.location.reload();
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/pages/ResetPassword/ResetPassword.js